import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e764684"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Properties", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "properties_parameter"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Parameters", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = ["for"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["id", "onUpdate:modelValue"]
const _hoisted_9 = {
  key: 1,
  class: "properties_color"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Colors", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { for: "color-picker-btn-fg" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { for: "color-picker-btn-bg" }
const _hoisted_15 = {
  key: 2,
  class: "properties_attributes"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Display Attributes", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { for: "attribute-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bold", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { for: "attribute-dim" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Dim", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { for: "attribute-italic" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Italic", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { for: "attribute-underline" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Underline", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { for: "attribute-blink" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Blink", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { for: "attribute-reverse" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reverse", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = { for: "attribute-overline" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Overline", -1))
const _hoisted_38 = { class: "properties_actions" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actions", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You have not selected an element.", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click on an element in your prompt to change its properties.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_ctx.selected !== null && _ctx.element !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["properties-wrapper", { dark: _ctx.darkMode }])
        }, [
          (_ctx.element.type.parameters.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element.type.parameters, (parameter) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: parameter.id,
                    for: parameter.id
                  }, [
                    _createTextVNode(_toDisplayString(parameter.label), 1),
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      autocomplete: "off",
                      id: 'parameter_' + parameter.id,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.element.parameters[parameter.id]) = $event)
                    }, null, 8, _hoisted_8), [
                      [_vModelText, _ctx.element.parameters[parameter.id]]
                    ])
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.element.type.printable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createVNode(_component_Popper, {
                  placement: "left-start",
                  arrow: ""
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_ColorPicker, {
                      selectedColor: _ctx.element.foregroundColor ?? undefined,
                      onSelectColor: _ctx.selectFg
                    }, null, 8, ["selectedColor", "onSelectColor"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_12, [
                      _createElementVNode("input", {
                        type: "button",
                        id: "color-picker-btn-fg",
                        class: _normalizeClass(["color-picker-btn", { selected: _ctx.element.foregroundColor !== null }]),
                        style: _normalizeStyle({
              backgroundColor: _ctx.element.foregroundColor ? `${_ctx.element.foregroundColor!.hex} !important` : undefined
            })
                      }, null, 6),
                      _createTextVNode(" Foreground color ")
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_13,
                _createVNode(_component_Popper, {
                  placement: "left-start",
                  arrow: ""
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_ColorPicker, {
                      selectedColor: _ctx.element.backgroundColor ?? undefined,
                      onSelectColor: _ctx.selectBg
                    }, null, 8, ["selectedColor", "onSelectColor"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_14, [
                      _createElementVNode("input", {
                        type: "button",
                        id: "color-picker-btn-bg",
                        class: _normalizeClass(["color-picker-btn", { selected: _ctx.element.backgroundColor !== null }]),
                        style: _normalizeStyle({
              backgroundColor: _ctx.element.backgroundColor ? `${_ctx.element.backgroundColor!.hex} !important` : undefined
            })
                      }, null, 6),
                      _createTextVNode(" Background color ")
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.element.type.printable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("label", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-bold",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.element.attributes.bold) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.bold]
                  ]),
                  _hoisted_19
                ]),
                _hoisted_20,
                _createElementVNode("label", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-dim",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.element.attributes.dim) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.dim]
                  ]),
                  _hoisted_22
                ]),
                _hoisted_23,
                _createElementVNode("label", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-italic",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.element.attributes.italic) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.italic]
                  ]),
                  _hoisted_25
                ]),
                _hoisted_26,
                _createElementVNode("label", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-underline",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.element.attributes.underline) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.underline]
                  ]),
                  _hoisted_28
                ]),
                _hoisted_29,
                _createElementVNode("label", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-blink",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.element.attributes.blink) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.blink]
                  ]),
                  _hoisted_31
                ]),
                _hoisted_32,
                _createElementVNode("label", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-reverse",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.element.attributes.reverse) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.reverse]
                  ]),
                  _hoisted_34
                ]),
                _hoisted_35,
                _createElementVNode("label", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "attribute-overline",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.element.attributes.overline) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.element.attributes.overline]
                  ]),
                  _hoisted_37
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _hoisted_40,
            _createVNode(_component_IconButton, {
              icon: "Square2StackIcon",
              title: "Duplicate element",
              onClick: _ctx.duplicate
            }, null, 8, ["onClick"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_EmptyState, { empty: _ctx.empty }, {
      default: _withCtx(() => [
        _hoisted_41,
        _hoisted_42
      ]),
      _: 1
    }, 8, ["empty"])
  ], 64))
}